import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import {
  TntCenterService,
  TntSystemService,
  ApplicationService,
  TntToolTypeService,
}
  from '../../tnt.service';
import { MescService } from '../../../mesc/mesc.service';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';

@Component({
  selector: 'app-tool-identification-matrix',
  templateUrl: './tool-identification-matrix.component.html',
  host: { 'class': 'router-outlet' },

  // styleUrls: ['./tool-identification-matrix.component.scss']
})
export class ToolIdentificationMatrixComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    public TntCenterService: TntCenterService,
    public TntSystemService: TntSystemService,
    public ApplicationService: ApplicationService,
    public TntToolTypeService: TntToolTypeService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private cgpSnackbarService: CgpSnackbarService,
  ) {
  }
  isNew: boolean = false
  selectedCenter: any = undefined;
  selectedSystem: any = undefined;
  selectedApp: any = undefined;
  selectedToolType: any = undefined;
  RecycledItem: string = undefined;
  formGroup: FormGroup;

  public defaultCenter: {
    CenterDescription: string,
    CenterId: string
  } = {
      CenterDescription:
        "Select Center", CenterId: undefined
    };
  public defaultSystem: {
    SystemDescription: string,
    SystemId: string
  } = {
      SystemDescription:
        "Select System", SystemId: undefined
    };
  public defaultApp: {
    AppDescription: string,
    AppId: string
  } = {
      AppDescription:
        "Select App", AppId: undefined
    };
  public defaultToolType: {
    ToolTypeDescription: string,
    ToolTypeId: string
  } = {
      ToolTypeDescription:
        "Select Tool Type", ToolTypeId: undefined
    };

  public dataResultCenter: Array<"Center">;
  public dataResultTntSystem: Array<"TntSystem">;
  public dataResultApplication: Array<"Application">;
  public dataResultTntToolType: Array<"TntToolType">;

  public ngOnInit() {
    var self = this;
    this.TntCenterService.read("", true).then(function (response) {
      self.TntCenterService.data = response.filter(function (center) {
        return center.Description !== "Body Shop";
      });
    });
    this.TntSystemService.query();
    this.ApplicationService.query();
    this.TntToolTypeService.query();

    this.formGroup = this.addForm;
  }

  addForm = this.formBuilder.group({
    Id: [],
    SystemDescription: ["", Validators.required],
    ApplicationDescription: ["", Validators.required],
    ToolTypeDescription: ["", Validators.required],
    ApplicationId: [""],
    TntSystemId: [""],
    Description: [""],
    CenterId: [""],
    IsActive: [true],
  })

  SystemEditForm = this.formBuilder.group({
    Id: [],
    CreatedDate: [],
    CreatedBy: [],
    Description: [""],
    CenterId: [""],
    IsActive: [true],
  })

  AppEditForm = this.formBuilder.group({
    Id: [],
    CreatedDate: [],
    CreatedBy: [],
    Description: [""],
    TntSystemId: [""],
    IsActive: [true],
  })

  TTEditForm = this.formBuilder.group({
    Id: [],
    CreatedDate: [],
    CreatedBy: [],
    Description: [""],
    ApplicationId: [""],
    IsActive: [true],
  })

  //Form Dialogs..//

  formDialog = {
    title: '',
    formControls: []
  };

  addSystemFormDialog = {
    title: "System",
    formControls: [
      {
        type: "text",
        name: "SystemDescription",
        title: "System",
      },
      {
        type: "text",
        name: "ApplicationDescription",
        title: "Application",
      },
      {
        type: "text",
        name: "ToolTypeDescription",
        title: "Tool Type",
      }
    ]
  };

  editSystemFormDialog = {
    title: "System",
    formControls: [
      {
        type: "text",
        name: "Description",
        title: "Description",
      },
    ]
  }

  addApplicationFormDialog = {
    title: "Application",
    formControls: [
      {
        type: "text",
        name: "SystemDescription",
        title: "System",
        readonly: 'always'
      },
      {
        type: "text",
        name: "Description",
        title: "Application",
      },
      {
        type: "text",
        name: "ToolTypeDescription",
        title: "Tool Type",
      }
    ]
  }

  editApplicationFormDialog = {
    title: "Application",
    formControls: [
      {
        type: "text",
        name: "Description",
        title: "Description",
      },
    ],
  }

  addToolTypeFormDialog = {
    title: "Tool Type",
    formControls: [
      {
        type: "text",
        name: "SystemDescription",
        title: "System",
        readonly: 'always'
      },
      {
        type: "text",
        name: "ApplicationDescription",
        title: "Application",
        readonly: 'always'
      },
      {
        type: "text",
        name: "Description",
        title: "Tool Type",
      }
    ],
  }


  editToolTypeFormDialog = {
    title: "Tool Type",
    formControls: [
      {
        type: "text",
        name: "Description",
        title: "Description",
      },
    ],
  }


  //Filter Handlers
  handleFilter() { }

  //System 

  handleCenterChange(value: any, clearValues: boolean = true) {
    this.selectedCenter = value;
    if (!clearValues) {
      this.selectedApp = undefined;
      this.selectedSystem = undefined;
      this.selectedToolType = undefined;
    }

    if (value) {

      this.dataResultTntSystem =
        this.TntSystemService.data.filter((s) => {
          return s.CenterId == value.Id;

        })
    } else {
      this.handleSystemChange(undefined);
    }
  }

  // App

  handleSystemChange(value: any, clearValues: boolean = true) {
    this.selectedSystem = value;
    if (clearValues) {
      this.selectedApp = undefined;
      this.selectedToolType = undefined;
    }

    if (value) {

      this.dataResultApplication =
        this.ApplicationService.data.filter((s) => {
          return s.TntSystemId == value.Id;

        })
    } else {
      this.handleAppChange(undefined);
    }
  }

  // Tool Type

  handleAppChange(value: any, clearValues: boolean = true) {
    this.selectedApp = value;
    if (clearValues) {
      this.selectedToolType = undefined;
    }

    if (value) {

      this.dataResultTntToolType =
        this.TntToolTypeService.data.filter((s) => {
          return s.ApplicationId == value.Id;

        })
    } else {
      this.handleToolTypeChange(undefined);
    }
  }

  handleToolTypeChange(value: any) {
    this.selectedToolType = value;
  }

  // Add Handlers

  AddSystemHandler(form) {
    this.setModelHandler();
    this.formDialog = form;
    this.formGroup = this.addForm;
    this.formGroup.controls["ApplicationDescription"].setValidators(Validators.required);
    this.formGroup.controls["ToolTypeDescription"].setValidators(Validators.required);
    this.formGroup.controls["Description"].setValidators(null);
    this.editDataItem.CenterId = this.selectedCenter.Id;
    this.editDataItem.IsActive = true;
    this.RecycledItem = "System";
    this.isNew = true;
  }

  addAppHandler(form) {
    this.setModelHandler();
    this.RecycledItem = "App";
    this.formDialog = form;
    this.formGroup = this.addForm;
    this.formGroup.controls["ApplicationDescription"].setValidators(null);
    this.formGroup.controls["ToolTypeDescription"].setValidators(Validators.required);
    this.formGroup.controls["Description"].setValidators(Validators.required);
    this.editDataItem.TntSystemId = this.selectedSystem.Id;
    this.editDataItem.SystemDescription = this.selectedSystem.Description;
    this.editDataItem.IsActive = true;
    this.isNew = true;
  }

  addTTHandler(form) {
    this.setModelHandler();
    this.RecycledItem = "ToolType";
    this.formDialog = form;
    this.formGroup = this.addForm;
    this.formGroup.controls["ToolTypeDescription"].setValidators(null);
    this.formGroup.controls["Description"].setValidators(Validators.required);
    this.editDataItem.ApplicationId = this.selectedApp.Id;
    this.editDataItem.SystemDescription = this.selectedSystem.Description;
    this.editDataItem.ApplicationDescription = this.selectedApp.Description;
    this.editDataItem.IsActive = true;
    this.isNew = true;
  }

  // Edit Handler
  EditSystemHandler(form) {
    this.setModelHandler();
    this.formDialog = form;
    this.formGroup = this.SystemEditForm;
    this.editDataItem.CenterId = this.selectedCenter.Id;
    this.editDataItem.Description = this.selectedSystem.Description;
    this.editDataItem.IsActive = true;
    this.editDataItem.Id = this.selectedSystem.Id;

    this.RecycledItem = "System";
    this.isNew = false;
  }


  EditAppHandler(form) {
    this.setModelHandler();
    this.formDialog = form;
    this.RecycledItem = "App";
    this.formGroup = this.AppEditForm;
    this.editDataItem.Description = this.selectedApp.Description;
    this.editDataItem.Id = this.selectedApp.Id;
    this.editDataItem.TntSystemId = this.selectedSystem.Id;
    this.editDataItem.SystemDescription = this.selectedSystem.Description;
    this.editDataItem.IsActive = true;
    this.isNew = false;
  }

  EditTTHandler(form) {
    this.setModelHandler();
    this.formDialog = form;
    this.RecycledItem = "ToolType";
    this.formGroup = this.TTEditForm;
    this.editDataItem.ApplicationId = this.selectedApp.Id;
    this.editDataItem.Description = this.selectedToolType.Description;
    this.editDataItem.Id = this.selectedToolType.Id;
    this.editDataItem.IsActive = true;
    this.isNew = false;
  }

  SystemRemoveHandler() {
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Delete Confirmation',
      message: 'Are you sure that you want to delete ' + this.selectedSystem.Description + '?',
      alert: 'danger',
      onYesClick: () => {
        this.TntSystemService.remove('/' + this.selectedSystem.Id, false)
          .then(() => {
            this.TntSystemService.read().then(() => {
              this.handleCenterChange(this.selectedCenter);
              this.handleSystemChange(undefined);
              this.ApplicationService.read("", true);
              this.TntToolTypeService.read("", true);

              this.cgpSnackbarService.showSnackbar({
                message: "Record has been deleted",
                duration: 2000
              });
            })
          })
          .catch(e => this.handleError(e, this.TntSystemService));
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }

  AppRemoveHandler() {
    var self = this;
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Delete Confirmation',
      message: 'Are you sure that you want to delete ' + this.selectedApp.Description + '?',
      alert: 'danger',
      onYesClick: () => {
        this.ApplicationService.remove('/' + this.selectedApp.Id, false)
          .then(() => {
            this.ApplicationService.read("", true).then(() => {
              this.handleSystemChange(this.selectedSystem);
              this.handleAppChange(undefined);
              this.TntSystemService.read("", true);
              this.TntToolTypeService.read("", true);
            })
            this.cgpSnackbarService.showSnackbar({
              message: "Record has been deleted",
              duration: 2000
            });
          }).catch(function (response) {
            self.ApplicationService.loading.next(false);;
            self.cgpAlertDialogService.showAlertDialog({
              title: 'Error',
              message: response.error.Message,
              alert: 'danger',
              closeLabel: 'Close',
            })
          })
          .catch(e => this.handleError(e, this.ApplicationService));
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }


  ToolTypeRemoveHandler() {
    var self = this;
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Delete Confirmation',
      message: 'Are you sure that you want to delete ' + this.selectedToolType.Description + '?',
      alert: 'danger',
      onYesClick: () => {
        this.TntToolTypeService.remove('/' + this.selectedToolType.Id, false)
          .then(() => {
            this.TntToolTypeService.read().then(() => {
              this.handleAppChange(this.selectedApp);
              this.ApplicationService.read("", true);
              this.TntSystemService.read("", true);
            })
            this.cgpSnackbarService.showSnackbar({
              message: "Record has been deleted",
              duration: 2000
            });
          }).catch(response => {
            self.TntToolTypeService.loading.next(false);;
            this.cgpAlertDialogService.showAlertDialog({
              title: 'Error',
              message: response.error.ExceptionMessage,
              alert: 'danger',
              closeLabel: 'Close',
            })
          })
          .catch(e => this.handleError(e, this.TntToolTypeService));
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }


  SaveRecycleHandler(dataItem) {

    if (this.RecycledItem == "System") {
      this.TntSystemService.save(this.formGroup.value, this.isNew, "", this.isNew, false).then(() => {
        this.TntSystemService.read("", true).then(() => {
          this.handleCenterChange(this.selectedCenter, false);
          this.ApplicationService.read("", true).then(() => {
            this.isNew ? this.handleSystemChange(this.selectedSystem, false) : this.handleSystemChange(dataItem, false);
            this.TntToolTypeService.read("", true).then(() => {
              this.handleAppChange(this.selectedApp, false);
            });
          });

        })
        this.cgpSnackbarService.showSnackbar({
          message: this.isNew ? 'Record has been created' : 'Record has been updated',
          duration: 2000
        })
      }).catch(response => {
        this.TntSystemService.loading.next(false);;
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
    }
    else if (this.RecycledItem == "App") {
      this.ApplicationService.save(this.formGroup.value, this.isNew, "", this.isNew, false).then(() => {
        this.ApplicationService.read("", true).then(() => {
          this.handleSystemChange(this.selectedSystem, false);
          this.TntToolTypeService.read("", true).then(() => {
            this.isNew ? this.handleAppChange(this.selectedApp, false) : this.handleAppChange(dataItem, false);
          });
        })
        this.cgpSnackbarService.showSnackbar({
          message: this.isNew ? 'Record has been created' : 'Record has been updated',
          duration: 2000
        })
      }).catch(response => {
        this.ApplicationService.loading.next(false);;
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
    }
    else if (this.RecycledItem == "ToolType") {
      this.TntToolTypeService.save(this.formGroup.value, this.isNew, "", this.isNew, false).then(() => {
        this.TntToolTypeService.read("", true).then(() => {
          this.handleAppChange(this.selectedApp, false);
        })
        this.cgpSnackbarService.showSnackbar({
          message: this.isNew ? 'Record has been created' : 'Record has been updated',
          duration: 2000
        })
      }).catch(response => {
        this.TntToolTypeService.loading.next(false);;
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
    }
  }

  handleError = (e, service: MescService) => {
    service.loading.next(false);;
    this.cgpAlertDialogService.showAlertDialog({
      title: 'Error',
      message: e._body.replace(/"/g, ''),
      alert: 'danger',
      closeLabel: 'Close',
    });
  }

  editDataItem = undefined
  setModelHandler(): void {
    this.editDataItem = new tempSystem();
  }
  cancelHandler(): void {
    this.editDataItem = undefined

  }

}


class tempSystem {
  Id: 1;
  SystemName: any;

}










